import { differenceInCalendarDays } from 'date-fns';

import { awsDateToDateObject } from 'core/helpers/formatters';

// How far apart a custom billing day puts the 1st and 2nd payments (#36361). Under 15 days the agent must
// choose to keep them separate or combine them; from 15 to 30 the modal says how far apart they land.
export const SpacingBucket = Object.freeze({
  Under15: 'under-15',
  From15To30: '15-to-30',
  Over30: 'over-30'
});

const MIN_SEPARATE_DAYS = 15;
const MAX_CLOSE_DAYS = 30;

export const CloseResolution = Object.freeze({
  KeepSeparate: 'keep-separate',
  Combine: 'combine'
});

// Calendar days from the 1st payment (due at bind) to the 2nd, or null without a 2nd payment.
export const getDaysBetweenFirstTwoPayments = (schedule) => {
  const [firstPayment, secondPayment] = schedule ?? [];
  if (!firstPayment?.date || !secondPayment?.date) {
    return null;
  }
  return differenceInCalendarDays(awsDateToDateObject(secondPayment.date), awsDateToDateObject(firstPayment.date));
};

export const getSpacingBucket = (days) => {
  if (days == null) {
    return null;
  }
  if (days < MIN_SEPARATE_DAYS) {
    return SpacingBucket.Under15;
  }
  return days <= MAX_CLOSE_DAYS ? SpacingBucket.From15To30 : SpacingBucket.Over30;
};
